import mixpanel from "mixpanel-browser";
import { ENVIRONMENT, MIXPANEL_TOKEN } from "../constants";

mixpanel.init(MIXPANEL_TOKEN, { debug: ENVIRONMENT !== "production" });

export default function useMixpanel() {
	return mixpanel;
}
